import { Col, Row } from "antd";
import {
  FaixaConsumoDto,
  EditarConsumoForm,
  ConsumoDto,
} from "core/features/consumo/typings";
import { Control, UseFormSetValue } from "react-hook-form";
import AddRemoveLineButton from "ui/components/Button/AddRemoveLineButton";
import Field from "ui/components/Input/Field";
import InputMoney from "ui/components/Input/InputMoney";
import { Box } from "@chakra-ui/react";
import SelectFaixaConsumoTipoValor from "components/Input/SelectFaixaConsumoTipoValor";

interface FaixaConsumoItemProps {
  control: Control<EditarConsumoForm>;
  setValue: UseFormSetValue<EditarConsumoForm>;
  faixas: FaixaConsumoDto[];
  index: number;
  consumo?: ConsumoDto;
}

function FaixaConsumoItem({
  control,
  index,
  faixas,
  setValue,
  consumo,
}: FaixaConsumoItemProps) {
  const onRemove = (index: number) => {
    const copy = [...faixas];
    copy.splice(index, 1);
    setValue("faixas", copy ?? []);
  };

  return (
    <Box as={Row} gutter={16} mb={4}>
      <Col sm={6}>
        <Field
          label={
            index === 0
              ? consumo?.unidadeMedida
                ? `Valor`
                : "Valor por medida"
              : undefined
          }
          control={control}
          rules={{
            required: true,
          }}
          name={`faixas.${index}.valor`}
          render={({ field, isInvalid }) => (
            <InputMoney
              isInvalid={isInvalid}
              value={faixas[index].valor ?? undefined}
              onChange={field.onChange}
            />
          )}
        />
      </Col>

      <Col sm={5}>
        <Field
          label={
            index === 0
              ? `Início da faixa ${
                  consumo?.unidadeMedida ? `(${consumo?.unidadeMedida})` : ""
                }`
              : undefined
          }
          control={control}
          rules={{
            validate: (v) => {
              if (index === 0) return true;

              if (index > 0 && !Number.isFinite(v)) {
                return "Somente a primeira faixa pode ter o início em aberto";
              }

              const previousFaixa = faixas[index - 1];

              return (
                previousFaixa?.fimFaixa === v ||
                "O início da faixa deve ser igual ao fim da faixa anterior"
              );
            },
          }}
          name={`faixas.${index}.inicioFaixa`}
          render={({ field, isInvalid }) => (
            <InputMoney
              isInvalid={isInvalid}
              value={faixas[index].inicioFaixa ?? undefined}
              onChange={field.onChange}
            />
          )}
        />
      </Col>

      <Col sm={5}>
        <Field
          label={
            index === 0
              ? `Fim da faixa ${
                  consumo?.unidadeMedida ? `(${consumo?.unidadeMedida})` : ""
                }`
              : undefined
          }
          control={control}
          rules={{
            validate: (v) => {
              const faixa = faixas[index];
              if (index !== faixas.length - 1 && !v) {
                return "Somente a última faixa pode ter o fim em aberto";
              }

              if (
                Number.isFinite(v) &&
                faixa.inicioFaixa &&
                v < faixa.inicioFaixa
              ) {
                return "O final da faixa deve ser maior ou igual ao início";
              }

              return true;
            },
          }}
          name={`faixas.${index}.fimFaixa`}
          render={({ field, isInvalid }) => (
            <InputMoney
              isInvalid={isInvalid}
              value={faixas[index].fimFaixa ?? undefined}
              onChange={(v) => {
                console.log("v", v);
                field.onChange(v);
              }}
              allowUndefined
            />
          )}
        />
      </Col>

      <Col sm={6}>
        <Field
          label={index === 0 ? "Tipo de cobrança" : undefined}
          control={control}
          rules={{
            required: true,
          }}
          name={`faixas.${index}.tipoValor`}
          render={({ field }) => (
            <SelectFaixaConsumoTipoValor
              value={faixas[index].tipoValor ?? undefined}
              onChange={field.onChange}
              allowClear
              unidadeMedidaLabel={
                consumo?.unidadeMedida
                  ? `Por ${consumo?.unidadeMedida}`
                  : undefined
              }
            />
          )}
        />
      </Col>

      <Col sm={2} style={{ height: "fit-content" }}>
        <AddRemoveLineButton
          showAdd={false}
          onRemove={() => onRemove(index)}
          containerProps={{
            pt: index > 0 ? 1 : 6,
          }}
        />
      </Col>
    </Box>
  );
}

export default FaixaConsumoItem;
